// src/i18n.js

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from '../locales/en/translation.json';
import arTranslation from '../locales/ar/translation.json';
import tnTranslation from '../locales/tn/translation.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslation
    },
    ar: {
      translation: arTranslation
    },
    tn: {
      translation: tnTranslation
    }
  },
  lng: 'en', // default language
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false // React already does escaping
  }
});

export default i18n;